import Axios from 'axios';

export const MicrositiosServices = {
    api: {
        async getAll() {
            return Axios.get('micrositios')
                .then((response) => response.data)
                .catch((error) => { throw error });
        },
        async find(id) {
            return Axios.get('micrositios/' + id)
                .then((response) => response.data)
                .catch((error) => { throw error });
        },
        async save(micrositio) {
            return Axios.post('micrositios', micrositio)
                .then((response) => response.data)
                .catch((error) => { throw error });
        },
        async put(id, micrositio) {
            return Axios.put('micrositios/' + id, micrositio)
                .then((response) => response.data)
                .catch((error) => { throw error });
        },
        async delete(id) {
            return Axios.delete('micrositios/' + id)
                .then((response) => response.data)
                .catch((error) => { throw error });
        },
    },
}
